import { useState } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  IconButton,
  Typography
} from '@mui/material'
import { useQuery } from '@tanstack/react-query'
import Calendar from '../../../../../components/Calendar/Calendar'
import { useNotification } from '../../../../../context/NotificationManager/NotificationManager'
import {
  dateFromUnixTimestamp,
  dateToMonth,
  dateToString,
  dateToTimeString,
  getStartOfMonth,
  monthToString
} from '../../../../../utils/date'
import { getAsistenciasClassfy } from '../../../../../utils/api/accesoClassfy'
import css from './SesionesClassfy.module.css'

const SesionClassfyEvento = ({
  startTime,
  endTime,
  teacherName,
  subjectName
}) => (
  <div className={css.calendarEvent}>
    <p className={css.calendarEventRow}>
      {dateToTimeString(startTime)} - {dateToTimeString(endTime)}
    </p>
    {subjectName && (
      <p className={css.calendarEventRow}>
        <span className={css.calendarEventAsignatura}>{subjectName}</span>
      </p>
    )}
    {teacherName && (
      <p className={css.calendarEventRow}>
        <span className={css.calendarEventDetail}>{teacherName}</span>
      </p>
    )}
  </div>
)

const SesionesClassfy = ({ alumnoId }) => {
  const notification = useNotification()
  const [mes, setMes] = useState(getStartOfMonth())
  const [isExpanded, setExpanded] = useState(true)

  const handleExpandedChange = (_event, expanded) => setExpanded(expanded)

  const handleMonthChange = offset => {
    const newMes = new Date(mes)
    newMes.setMonth(newMes.getMonth() + offset)
    setMes(newMes)
  }

  const { data: sesiones = [] } = useQuery({
    queryKey: [
      'classfy',
      'asistencia-classfy',
      'list',
      'alumno',
      alumnoId,
      monthToString(mes)
    ],
    queryFn: () =>
      getAsistenciasClassfy({
        alumno: alumnoId,
        mes: monthToString(mes)
      }).catch(err => {
        notification.error({
          title: 'Error al recuperar las sesiones de Classfy',
          content: err
        })
        return []
      })
  })

  const sesionesCalendario = sesiones.reduce((acc, sesion) => {
    const startDate = dateFromUnixTimestamp(sesion.startTime)
    const endDate = dateFromUnixTimestamp(sesion.endTime)
    if (!startDate) return acc
    const fecha = dateToString(startDate)
    const evento = (
      <SesionClassfyEvento
        key={sesion.id}
        startTime={startDate}
        endTime={endDate}
        teacherName={sesion.teacherName}
        subjectName={sesion.subjectName}
      />
    )
    return { ...acc, [fecha]: [...(acc[fecha] || []), evento] }
  }, {})

  return (
    <Accordion expanded={isExpanded} onChange={handleExpandedChange}>
      <AccordionSummary
        expandIcon={<i className='material-icons'>expand_more</i>}
      >
        <Typography className={css.title} variant='h2'>
          Clases en Classfy
        </Typography>
      </AccordionSummary>
      <AccordionDetails>
        <div className={css.calendar}>
          <div className={css.monthSelection}>
            <IconButton
              className={css.monthIcon}
              size='small'
              onClick={() => handleMonthChange(-1)}
            >
              <i className='material-icons'>arrow_back</i>
            </IconButton>
            <p className={css.calendarMonth}>{dateToMonth(mes)}</p>
            <IconButton
              className={css.monthIcon}
              size='small'
              onClick={() => handleMonthChange(+1)}
            >
              <i className='material-icons'>arrow_forward</i>
            </IconButton>
          </div>
          <Calendar month={monthToString(mes)} events={sesionesCalendario} />
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default SesionesClassfy
